import React from 'react';
import { cn } from '@datanomik/core-ui';
import { AnimationDirection } from './types';

interface AnimatedEntranceProps {
  children: React.ReactNode;
  duration?: number;
  delay?: number;
  distance?: number;
  direction?: AnimationDirection;
  className?: string;
}

export const enterOffset = (direction: AnimationDirection, distance: number) => {
  switch (direction) {
    case 'down': return `translateY(-${distance}px)`;
    case 'left': return `translateX(${distance}px)`;
    case 'right': return `translateX(-${distance}px)`;
    case 'up':
    default: return `translateY(${distance}px)`;
  }
};

const AnimatedEntrance: React.FC<AnimatedEntranceProps> = ({
  children,
  duration = 0.3,
  delay = 0,
  distance = 20,
  direction = 'up',
  className,
}) => (
  <div
    className={cn('opacity-0 invisible', className)}
    style={{
      '--dnk-enter-from': enterOffset(direction, distance),
      transform: enterOffset(direction, distance),
      animation: `dnk-enter ${duration}s ease-in-out ${delay}s forwards`,
    } as React.CSSProperties}
  >
    {children}
  </div>
);

export default AnimatedEntrance;
